export default {
  placeholder: 'Wpisz nazwę restauracji',
  labels: {
    cant_find_place: 'Nie możesz znaleźć miejsca na liście?',
    reset_categories: 'Resetuj kategorie miejsc',
  },
};
